export const GET_TEMPLATE = "GET_TEMPLATE"
export const GET_TEMPLATE_SUCCESS = "GET_TEMPLATE_SUCCESS"
export const GET_TEMPLATE_FAIL = "GET_TEMPLATE_FAIL"

export const SAVE_TEMPLATE = "SAVE_TEMPLATE"
export const SAVE_TEMPLATE_SUCCESS = "SAVE_TEMPLATE_SUCCESS"
export const SAVE_TEMPLATE_FAIL = "SAVE_TEMPLATE_FAIL"

export const GET_REPORT = "GET_REPORT"
export const GET_REPORT_SUCCESS = "GET_REPORT_SUCCESS"
export const GET_REPORT_FAIL = "GET_REPORT_FAIL"

export const SAVE_REPORT = "SAVE_REPORT"
export const SAVE_REPORT_SUCCESS = "SAVE_REPORT_SUCCESS"
export const SAVE_REPORT_FAIL = "SAVE_REPORT_FAIL"

export const UPDATE_REPORT = "UPDATE_REPORT"
export const UPDATE_REPORT_SUCCESS = "UPDATE_REPORT_SUCCESS"
export const UPDATE_REPORT_FAIL = "UPDATE_REPORT_FAIL"

export const DELETE_REPORT = "DELETE_REPORT"
export const DELETE_REPORT_SUCCESS = "DELETE_REPORT_SUCCESS"
export const DELETE_REPORT_FAIL = "DELETE_REPORT_FAIL"

export const GET_DRAFT_REPORT = "GET_DRAFT_REPORT"
export const GET_DRAFT_REPORT_SUCCESS = "GET_DRAFT_REPORT_SUCCESS"
export const GET_DRAFT_REPORT_FAIL = "GET_DRAFT_REPORT_FAIL"

export const RESET_MESSAGE = "RESET_MESSAGE"

export const PUBLISH_DRAFT = "PUBLISH_DRAFT"
export const PUBLISH_DRAFT_SUCCESS = "PUBLISH_DRAFT_SUCCESS"
export const PUBLISH_DRAFT_FAIL = "PUBLISH_DRAFT_FAIL"